<template>
  <div>
    <div class="row">
      <div v-for="(card,index) in cards" :key="card.title">
        <div :class="{lightgrey: index % 2 === 0}" class="col s12">
          <div class="col s12 m10 l8 offset-m1 offset-l2">
            <h2 class="header">{{$t(card.title)}}</h2>
            <div class="card horizontal">
              <div class="card-image">
                <img :src="card.img.link" :alt="$t(card.img.alt)"/>
              </div>
              <div class="card-stacked">
                <div class="card-content">
                  <p v-html="$t(card.desc)"></p>
                </div>
                <div class="card-action"><p v-html="$t(card.action)"></p></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MachineLearning',
  data () {
    return {
      cards: [{
        title: 'ml.pong.title',
        img: {link: 'static/img/pong.jpg', alt: 'ml.pong.alt.pict'},
        desc: 'ml.pong.desc',
        action: 'ml.pong.action'
      }, {
        title: 'ml.chatbot.title',
        img: {link: 'static/img/chatbot.jpg', alt: 'ml.chatbot.alt.pict'},
        desc: 'ml.chatbot.desc',
        action: 'ml.chatbot.action'
      }, {
        title: 'ml.tictactoe.title',
        img: {link: 'static/img/tictactoe.png', alt: 'ml.tictactoe.alt.pict'},
        desc: 'ml.tictactoe.desc',
        action: 'ml.tictactoe.action'
      }]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MachineLearning.vue